module.exports = __webpack_public_path__ + "static/media/close-icon-gray.b25e20e4.svg";